// Leaderboard display component
import React from 'react';
import Avatar from './Avatar';

const Leaderboard = React.memo(({ scores, showCategoryBreakdown = false, categories = [], players = [], onPlayerClick }) => {
  if (!scores || scores.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No scores available yet
      </div>
    );
  }

  const getRankDisplay = (rank) => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return rank;
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Rank
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Player
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Score
            </th>
            {showCategoryBreakdown && categories.map(cat => (
              <th key={cat.id} className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                {cat.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {scores.map((score, index) => {
            const player = players.find(p => p.id === score.playerId);
            return (
              <tr key={score.playerId} className={index < 3 ? 'bg-yellow-50' : ''}>
                <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {getRankDisplay(score.rank)}
                </td>
                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                  <div className="flex items-center gap-3">
                    {player && <Avatar player={player} size="sm" onClick={onPlayerClick ? () => onPlayerClick(player.id) : null} />}
                    <span
                      className={onPlayerClick ? 'cursor-pointer hover:text-blue-600 font-medium' : ''}
                      onClick={onPlayerClick ? () => onPlayerClick(score.playerId) : null}
                    >
                      {score.playerName}
                    </span>
                  </div>
                </td>
                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right font-semibold">
                  {score.score.toFixed(1)}
                </td>
                {showCategoryBreakdown && categories.map(cat => {
                  const breakdown = score.categoryBreakdown?.[cat.id];
                  // Handle both old format (number) and new format (object)
                  const placementPoints = typeof breakdown === 'object' ? breakdown.placementPoints : (breakdown || 0);
                  const actualScore = typeof breakdown === 'object' ? breakdown.actualScore : 0;

                  return (
                    <td key={cat.id} className="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                      <div className="flex flex-col items-end">
                        <span className="font-semibold text-gray-900">{placementPoints.toFixed(1)}</span>
                        {typeof breakdown === 'object' && (
                          <span className="text-xs text-gray-400">({actualScore.toFixed(1)})</span>
                        )}
                      </div>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
});

Leaderboard.displayName = 'Leaderboard';

export default Leaderboard;
